//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  signal,
  WritableSignal,
} from "@angular/core";

//local imports
import { PresenterRegistration } from "@app/shared";
import { AbstractRoomModel, RoomDisplayMode } from "@app/catalog-common";

@PresenterRegistration({
   types: [AbstractRoomModel],
})
@Component({
  selector: "room-presenter",
  template: '<room-item [id]="data().id" [room]="data()" [displayMode]="DisplayMode.Name" />',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RoomPresenterComponent {
  DisplayMode = RoomDisplayMode;
  
  public data: WritableSignal<AbstractRoomModel>;

  constructor() {
    this.data = signal<AbstractRoomModel>(null);
  }
}
